export default "__VITE_ASSET__B4nbK6NM__"